import React from 'react';
import { Route } from 'react-router';
import AccountSetting from 'pages/AccountSetting/AccountSetting';
import Account from 'pages/AccountSetting/Account';
import PublicProfile from 'pages/AccountSetting/PublicProfile';
import Checkout from 'pages/AccountSetting/Checkout';
import Receipt from 'pages/AccountSetting/Receipt';
import EmailNotification from 'pages/AccountSetting/EmailNotification';
import Billing from 'pages/AccountSetting/Billing/Billing';
import PaymentMethod from 'routes/Payments/components/PaymentMethod';
import PaymentMethodRegistrationForm from 'routes/Payments/components/PaymentMethod/RegistrationForm';
import createCustomRoute from 'hocs/createCustomRoute';
import BankAccount from './BankAccount';

const SettingRoutes = createCustomRoute('SettingRoutes', props => (
  <Route {...props} component={AccountSetting}>
    <Route path="accounts" component={Account} />
    <Route path="billing" component={Billing} />
    <Route path="bank_account" component={BankAccount} />
    <Route
      path="payment_methods/registrations/:id"
      components={PaymentMethodRegistrationForm}
    />
    <Route path="payment_methods" component={PaymentMethod} />
    <Route path="checkout" component={Checkout} />
    <Route path="public_profile" component={PublicProfile} />
    <Route path="receipt" component={Receipt} />
    <Route path="email" component={EmailNotification} />
  </Route>
));

export default SettingRoutes;
